
import firebase from 'firebase'

  // Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDFHUDqJ7O1-j3kmat7gqrm6yFFFkHQ6G4",
    authDomain: "bleed-proud-comment.firebaseapp.com",
    databaseURL: "https://bleed-proud-comment.firebaseio.com",
    projectId: "bleed-proud-comment",
    storageBucket: "bleed-proud-comment.appspot.com",
    messagingSenderId: "147074145722",
    appId: "1:147074145722:web:7fc3557a30a88b72c89183",
    measurementId: "G-BJVSW576JJ"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  firebase.analytics();
  
  export default firebase;